export default __webpack_public_path__ + "static/media/up-down.5a5e6e1e.svg";